import DeleteSharpIcon from "@mui/icons-material/DeleteSharp";
import {
  Autocomplete,
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Radio,
  RadioGroup,
  Select,
  SelectChangeEvent,
  TextField,
  Typography,
} from "@mui/material";
import {Formik} from "formik";
import Skeleton from "@mui/material/Skeleton";
import React, {FC, useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {fetchGroupUsersRequest} from "../../../store/groups/actions"
import {getGroupPendingSelector, getGroupUsersSelector} from "../../../store/groups/selectors";
import Back from '../../atoms/backButton'
import {
  getOverridePendingSelector,
  getOverrideSelector,
  postOverrideSelector,
  putOverrideSelector,
} from "../../../store/roleOverRide/selectors";
import {getProfileDataSelector, getRoleClaimsSelector} from "../../../store/auth/selectors";
import {DataField} from "../../atoms";
import {IUser} from "../../../store/groups/types";
import {IFormDropDown, IFormField} from "../../shared/globalTypes";
import * as constants from "../../../constants/_pickerValues";
import {useNavigate} from "react-router-dom";
import {useParams} from "react-router";
import * as functions from "../../shared/functions";
import * as actions from "../../../store/roleOverRide/actions";
import {fetchOverrideDetailsReq} from "../../../store/roleOverRide/actions";
import ExtractorExplorer from "../../../components/organisms/extractorExplorer/ExtractorExplorer";
import {fetchAccessControlRequest} from "../../../store/dataSource/actions";
import { getAccessControlPendingSelector, getAccessControlSelector } from "../../../store/dataSource/selectors";
import {IAccessControl} from "../../../store/dataSource/types";
import format from "date-fns/format";
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';
import {IDP_USERS_PRODUCTION, UDL_HUB_SERVICE_PRINCIPALS} from "../../../constants/common";

// Form fields object

export interface IOverrideFields {
  owner: IFormField;
  sourceId: IFormField;
  tableId: IFormField;
  grantee: IFormField;
  granteeType: IFormField;
  treatmentLevel: IFormField;
  expiryDate: IFormField;
  businessReason: IFormField;
}

export type granteeTypeList = {
  key: number;
  granteeType: string;
  grantee: string;
  isError: boolean;
};

export const granteeListInitialState = [
  {
    key: Date.now(),
    granteeType: "",
    grantee: "",
    isError: false,
  },
];

// Instantiating Override's initial state

let OverrideInitialState: IOverrideFields = {
  owner: { fieldValue: "", isError: false, errorMsg: "", isNumber: false },
  sourceId: { fieldValue: "", isError: false, errorMsg: "", isNumber: false },
  tableId: { fieldValue: "", isError: false, errorMsg: "", isNumber: false },
  grantee: { fieldValue: "", isError: false, errorMsg: "", isNumber: false },
  granteeType: {
    fieldValue: "",
    isError: false,
    errorMsg: "",
    isNumber: false,
  },
  treatmentLevel: {
    fieldValue: "",
    isError: false,
    errorMsg: "",
    isNumber: false,
  },
  expiryDate: { fieldValue: "", isError: false, errorMsg: "", isNumber: false },
  businessReason: { fieldValue: "", isError: false, errorMsg: "", isNumber: false },
};

let currentDate = new Date();

let expiryValueInitial = {
  days: 0,
  months: 0,
  day: currentDate.getDate(),
  month: currentDate.getMonth() + 1,
  year: currentDate.getFullYear(),
  fixedDate: new Date()
};

// mode for determining if form is for add, edit or view

interface Props {
  mode?: string;
}

const OverrideForm: FC<Props> = ({ mode = constants.MODE.add }: Props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const postOverride = useSelector(postOverrideSelector);
  const userProfile = useSelector(getProfileDataSelector);
  const idpUsersProduction = useSelector(getGroupUsersSelector(IDP_USERS_PRODUCTION));
  const idpUsersProductionPending = useSelector(getGroupPendingSelector(IDP_USERS_PRODUCTION));
  const udlHubServicePrincipals = useSelector(getGroupUsersSelector(UDL_HUB_SERVICE_PRINCIPALS));
  const udlHubServicePrincipalsPending = useSelector(getGroupPendingSelector(UDL_HUB_SERVICE_PRINCIPALS));
  const accessControls = useSelector(getAccessControlSelector);
  const accessControlsPending = useSelector(getAccessControlPendingSelector);
  const getOverride = useSelector(getOverrideSelector);
  const getOverridePending = useSelector(getOverridePendingSelector)
  const putOverride = useSelector(putOverrideSelector);
  const roles = useSelector(getRoleClaimsSelector);  // roles  - IDP.Admin or IDP.User

  const [overridesPrincipals, setOverridesPrincipals] =useState<IUser[]>([]);

  const [overrideFormData, setOverrideFormData] =
    useState(OverrideInitialState);
  const [ownerValue, setOwnerValue] = useState("");

  const [disableSaveBtn, setDisableSaveBtn] = useState(true);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [grantees, setGrantees] = useState<granteeTypeList[]>(
    mode === constants.MODE.add ? granteeListInitialState : []
  );
  const [expiryType, setExpiryType] = useState("");
  const [expiryValues, setExpiryValues] = useState(expiryValueInitial);
  const [typeError, setTypeError] = useState(false);
  const [tableError, setTableError] = useState(false);
  const [required, setRequired] = useState(true);
  const [overrideNavigation, SetOverrideNavigation] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [nonUDLSource, setNonUDLSource] = useState("");


  const { overrideId } = useParams();

  useEffect(() => {
        if (roles && roles.length > 0) {
            setIsAdmin(roles.includes("IDP.Admin"));
        }
    }, [roles]);

  useEffect(() => {
    window.scrollTo(0, 0)
    if(idpUsersProduction.length <= 0 && !idpUsersProductionPending) {
      dispatch(fetchGroupUsersRequest(IDP_USERS_PRODUCTION));
    }
    if(udlHubServicePrincipals.length <= 0 && !udlHubServicePrincipalsPending) {
      dispatch(fetchGroupUsersRequest(UDL_HUB_SERVICE_PRINCIPALS));
    }
    if (!accessControlsPending && accessControls.length <=0) {
      dispatch(fetchAccessControlRequest());
    }
  });

  useEffect(() => {
    if (postOverride !== null && postOverride !== undefined && overrideNavigation) {
      navigate("/OverRideList");
      SetOverrideNavigation(false);
    }
  }, [postOverride]);

  useEffect(() => {
    setOverridesPrincipals(idpUsersProduction.concat(udlHubServicePrincipals))
  }, [idpUsersProduction, udlHubServicePrincipals]);

  useEffect(() => {
    if (putOverride !== null && putOverride !== undefined && overrideNavigation) {
      navigate("/OverRideList");
      SetOverrideNavigation(false);
    }
  }, [putOverride]);

  // Handling owner changes

  useEffect(() => {
    overrideFormData.owner.fieldValue = ownerValue;
    setOverrideFormData(overrideFormData);
  }, [ownerValue]);

  useEffect(() => {
    if (userProfile) {
      setOwnerValue(userProfile["userPrincipalName"]);
      overrideFormData.owner.fieldValue = userProfile["userPrincipalName"];
      setOverrideFormData(overrideFormData);
    }
  }, [userProfile]);

  // Setting expiry date info

  useEffect(() => {
    setOverrideFormData({
      ...overrideFormData,
      expiryDate: functions.getFormField(""),
    });
  }, [expiryType]);

  useEffect(() => {
    let newDate = new Date();
    if (expiryType === "days") {
      newDate.setDate(newDate.getDate() + expiryValues.days);
    } else if (expiryType === "months") {
      newDate.setMonth(newDate.getMonth() + expiryValues.months);
    } else if (expiryType === "fixedDate") {
      newDate = expiryValues.fixedDate;
    }
    const formattedDate = format(newDate, "yyyy-MM-dd")
    setOverrideFormData({
      ...overrideFormData,
      expiryDate: functions.getFormField(formattedDate),
    });
  }, [expiryValues]);

  // GET override details, depending on override ID (when it is either VIEW or EDIT)

  useEffect(() => {
    // When override ID is available, when it is either VIEW or EDIT

    if (mode !== constants.MODE.add && overrideId) {
      dispatch(fetchOverrideDetailsReq(overrideId));
    }
  }, [overrideId]);

  // Update overrideFormData state
  useEffect(() => {
    if (
      (mode === constants.MODE.edit || mode === constants.MODE.view) &&
      getOverride
    ) {
      overrideFormData.owner.fieldValue = getOverride["owner"];
      overrideFormData.sourceId.fieldValue = getOverride["sourceId"];
      overrideFormData.tableId.fieldValue = getOverride["tableId"];
      overrideFormData.grantee.fieldValue = getOverride["grantee"];
      overrideFormData.granteeType.fieldValue = getOverride["granteeType"];
      overrideFormData.treatmentLevel.fieldValue = getOverride["treatmentLevel"];
      overrideFormData.expiryDate.fieldValue = getOverride["expiryDate"];
      overrideFormData.businessReason.fieldValue = getOverride["businessReason"] || "";

      //convert ExpiryDate to day/month and year
      setExpiryValues({ ...expiryValues, fixedDate: new Date(overrideFormData.expiryDate.fieldValue) });

      setExpiryType("fixedDate");
      setOverrideFormData(overrideFormData);

    } else {
      overrideFormData.owner.fieldValue = "";
      overrideFormData.sourceId.fieldValue = "";
      overrideFormData.tableId.fieldValue = "";
      overrideFormData.grantee.fieldValue = "";
      overrideFormData.treatmentLevel.fieldValue = "";
      overrideFormData.expiryDate.fieldValue = "";
      overrideFormData.businessReason.fieldValue = "";
      setOverrideFormData(overrideFormData);
    }
  }, [getOverride, mode]);

  const goBack = () => {
    window.history.back();
  };

  const editOverride = () => {
    navigate(`/EditOverride/${overrideId}`);

  };


  // Validate the required fields of the form
  // onBlur won't be able to determine if fields are empty unless the focus was on a field
  // Conditions are set on which to validate, depending on the connection type
  // Secret name to be generated each time a form is validated, as secret name is also a required field but is read-only

  const validate = () => {
    overrideFormData.owner.isError = overrideFormData.owner.fieldValue === "";
    overrideFormData.sourceId.isError =
      overrideFormData.sourceId.fieldValue === "";
    overrideFormData.tableId.isError =
      overrideFormData.tableId.fieldValue === "";
    overrideFormData.treatmentLevel.isError =
      overrideFormData.treatmentLevel.fieldValue === "";
    overrideFormData.expiryDate.isError =
      overrideFormData.expiryDate.fieldValue === "";
    overrideFormData.businessReason.isError =
      overrideFormData.businessReason.fieldValue === "";

    const validateKeys = [
      "owner",
      "sourceId",
      "tableId",
      "treatmentLevel",
      "expiryDate",
      "businessReason",
    ];

    const data = Object.fromEntries(
        Object.entries(overrideFormData).filter(([key]) =>
            validateKeys.includes(key)
        )
    );

    setOverrideFormData(overrideFormData);

    // Check if there are errors in any of the fields
    //check grantee validations
    const granteesError = grantees.filter(
        (x) => x.isError || x.grantee === ""
    );

    const overrideFormDataError = Object.values(data as IOverrideFields).filter(
        (x: IFormField) => x.isError || x.fieldValue === ""
    );

    if (overrideFormDataError.length > 0 || granteesError.length > 0) {
      setDisableSaveBtn(true);
    } else {
      setDisableSaveBtn(false);
    }
  };

  //validate
  useEffect(() => {
    validate();
  }, [overrideFormData, grantees]);

  // Create or update a new override
  // Called when the Save button is clicked

  function createNewOverride() {
    // Setup payload for POST override endpoint
    if (mode === constants.MODE.add) {
      let payload = grantees.map(
        (item: granteeTypeList, index: number, items: granteeTypeList[]) => {
          return {
            sourceId: overrideFormData.sourceId.fieldValue,
            tableId: overrideFormData.tableId.fieldValue,
            grantee: item.grantee,
            granteeType: item.granteeType,
            treatmentLevel: overrideFormData.treatmentLevel.fieldValue,
            expiryDate: overrideFormData.expiryDate.fieldValue,
            businessReason: overrideFormData.businessReason.fieldValue || null,
            sourceName: nonUDLSource
          };
        }
      );

      dispatch(actions.postOverrideRequest(payload));
      SetOverrideNavigation(true);
    } else {
      // TODO implement put override

      let payload = {
        treatmentLevel: overrideFormData.treatmentLevel.fieldValue,
        expiryDate: overrideFormData.expiryDate.fieldValue,
        businessReason: overrideFormData.businessReason.fieldValue || null
      }
      dispatch(actions.putOverrideRequest(overrideId!, payload));
      SetOverrideNavigation(true);
    }
  }

  const onSelectTable = (tableId: string, sourceId: string, sourceName: string) => {
    overrideFormData.sourceId.fieldValue = sourceId;
    overrideFormData.tableId.fieldValue = tableId;
    setNonUDLSource(sourceName);
    setOverrideFormData(overrideFormData);
  };

  const onGranteeChange = (inputGrantee: granteeTypeList) => {
    const newGrantees = grantees.map((item) => {
      if (item.key === inputGrantee.key) return inputGrantee;
      return item;
    });
    setGrantees(newGrantees);
  };

  const addGrantee = () => {
    setGrantees(
      grantees.concat({
        key: Date.now(),
        granteeType: "",
        grantee: "",
        isError: false,
      })
    );
  };

  const deleteGrantee = (id: number) => {
    if (grantees.length > 1) {
      const granteeItem = grantees.filter((item) => item.key !== id);
      setGrantees(granteeItem);
    } else {
      alert("At least one Grantee is required to submit Role Override.");
    }
  };

  const handleGranteeTypeChange = (event: SelectChangeEvent, key: number) => {
    onGranteeChange({
      key: key,
      granteeType: event.target.value,
      grantee: "",
      isError: false,
    });
  };

  const handleOverrideTypeChange = (e: SelectChangeEvent<string>) => {
    let field: IFormDropDown = {
      fieldValue: e.target.value,
      isError: false,
      errorMsg: "",
    };

    setOverrideFormData({ ...overrideFormData, [e.target.name]: field });
  };

  const onHandleBlur = (event: {}) => {
    const e = event as React.FocusEvent<HTMLInputElement>;
    (e.target.value === "" || !e.target.value) && required
      ? setTypeError(true)
      : setTypeError(false);
    setOverrideFormData(overrideFormData);
  };

  const onGranteeBlur = (event: {}) => {
    const e = event as React.FocusEvent<HTMLInputElement>;
    let value = grantees.find(
      (grantee) => grantee.key === parseInt(e.target.name)
    );
    (e.target.value === "" || !e.target.value) && required
      ? (value!.isError = true)
      : (value!.isError = false);
    setGrantees(grantees);
  };

  const handleChangeExpiryType = (event: React.ChangeEvent<HTMLInputElement>) => {
    setExpiryType((event.target as HTMLInputElement).value);
    setExpiryValues(expiryValueInitial);
  };

  const tableSelectorstyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 1300,
    background: "white",
    height: 700,
    p: 4,
    overflowY: "auto",
  };

  const buttonStyle = {
    bottom: "0%",
    left: "10%",
  };

  // Update fieldValue when it is changed; needed to update the UI of the text fields, text areas

  const handleChange = (event: {}) => {
    const e = event as React.ChangeEvent<HTMLInputElement>;
    (e.target.value === "" || !e.target.value) && required
      ? setTableError(true)
      : setTableError(false);
    setOverrideFormData({
      ...overrideFormData,
      [e.target.name]: functions.getFormField(e.currentTarget.value),
    });
  };

  return (
    <Formik initialValues={{}} onSubmit={() => { }}>
      <div>
        {mode === constants.MODE.view && (
          <Back title="Overrides List" />

        )}{" "}
        <h1 style={{ textAlign: "left" }}>{mode} Override</h1>
          {/* adding skeleton screen on loading */}
          {(mode === constants.MODE.view || mode === constants.MODE.edit) &&
            getOverridePending ? (
            <Box>
              <Grid container spacing={4}>
                <Grid item xs={6}>
                  <Skeleton animation="wave" height={60} />
                </Grid>
                <Grid item xs={6}>
                  <Skeleton animation="wave" height={60} />
                </Grid>
                <Grid item xs={4}>
                  <Skeleton animation="wave" height={60} />
                </Grid>
                <Grid item xs={4}>
                  <Skeleton animation="wave" height={60} />
                </Grid>
                <Grid item xs={4}>
                  <Skeleton animation="wave" height={60} />
                </Grid>
                <Grid item xs={6}>
                  <Skeleton animation="wave" height={60} />
                </Grid>
                <Grid item xs={6}>
                  <Skeleton animation="wave" height={60} />
                </Grid>
                <Grid item xs={12}>
                  <Skeleton animation="wave" height={60} />
                </Grid>
                <Grid item xs={6}>
                  <Skeleton animation="wave" height={60} />
                </Grid>
                <Grid item xs={6}>
                  <Skeleton animation="wave" height={60} />
                </Grid>
                <Grid item xs={6}>
                  <Skeleton animation="wave" height={60} />
                </Grid>
                <Grid item xs={6}>
                  <Skeleton animation="wave" height={60} />
                </Grid>
              </Grid>
            </Box>
          ) : (
        <div>
          <Grid container spacing={4}>
            <Grid item xs={8}>
              {mode === constants.MODE.add ? (
                <>
                  <Box>
                    <DataField id="9bc306d3-3549-4468-8690-e69e06c1a817"
                      name="tableId"
                      label="Select Table"
                      required
                      error={tableError}
                      value={overrideFormData.tableId.fieldValue}
                      onChange={handleChange}
                      onClick={handleOpen}
                    />
                  </Box>
                  <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    sx={{ overflowY: "auto" }}
                  >
                    <Box sx={tableSelectorstyle}>
                      <ExtractorExplorer
                        selectable={"single"}
                        selectedValue={overrideFormData.tableId.fieldValue}
                        onSelect={onSelectTable}
                        displayIcons={false}
                        displayActionButtons={false}
                            nonUdlTables={true}
                      />
                      <Typography
                        id="modal-modal-description"
                        sx={{ mt: 2, mb: 2 }}
                      />
                      <Box
                        sx={buttonStyle}
                        display="flex"
                        justifyContent="flex-end"
                      >
                        <Button id="05d1ef76-69ef-4e06-a10a-7bf7a0aabb1f"
                          color="primary"
                          variant="contained"
                          onClick={handleClose}
                        >
                          Close
                        </Button>
                        <Button id="fbb2e699-ffa1-4e74-a118-5f96810920c8"
                          color="primary"
                          variant="contained"
                          onClick={handleClose}
                          sx={{ ml: 1 }}
                        >
                          Select
                        </Button>
                      </Box>
                    </Box>
                  </Modal>
                </>
              ) : (
                <DataField id="63aadee2-cbf3-431b-80d4-5b37e3887640"
                  name="tableId"
                  label="Select Table"
                  value={overrideFormData.tableId.fieldValue}
                  readOnly={true}
                />
              )}
            </Grid>
            <Grid item xs={4}>
              <FormControl fullWidth required>
                <InputLabel id="override-type-label">Override Type</InputLabel>
                <Select
                  labelId="override-type-label"
                  label="Override Type"
                  name="treatmentLevel"
                  required
                  error={typeError}
                  value={overrideFormData.treatmentLevel.fieldValue}
                  onBlur={onHandleBlur}
                  disabled={mode === constants.MODE.view}
                  inputProps={{
                    readOnly: mode === constants.MODE.view,
                  }}
                  variant={
                    mode === constants.MODE.view ? "standard" : "outlined"
                  }
                  onChange={handleOverrideTypeChange}
                >
                  <MenuItem value="medium">Medium Treatment</MenuItem>
                  <MenuItem value="high">High Treatment</MenuItem>
                  <MenuItem value="access">Access</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            {mode === constants.MODE.add ? (
              <Grid item xs={12}>
                <>
                  <Box
                    display="flex"
                    justifyContent="flex-start"
                    style={{ marginBottom: "1em" }}
                  >
                    <Button id="f28079c3-8035-4fd7-b508-045c5ce6004c"
                      color="primary"
                      variant="contained"
                      onClick={addGrantee}
                    >
                      Add New Grantee
                    </Button>
                  </Box>
                  <div>
                    {grantees.map((grantee) => (
                      <React.Fragment key={grantee.key}>
                        <Box
                          sx={{
                            border: 1,
                            borderColor: "divider",
                            padding: 2,
                            width: "100%",
                            display: "block",
                          }}
                        >
                          <Grid container spacing={5} alignItems="center">
                            <Grid item xs={3}>
                              <FormControl fullWidth required>
                                <InputLabel>Grantee Type</InputLabel>
                                <Select
                                  labelId="grantee-type-label"
                                  label="Grantee Type"
                                  value={grantee.granteeType}
                                  onChange={(event) =>
                                    handleGranteeTypeChange(event, grantee.key)
                                  }
                                >
                                  <MenuItem value="individual">
                                    Individual
                                  </MenuItem>
                                  <MenuItem value="group">Group</MenuItem>
                                </Select>
                              </FormControl>
                            </Grid>
                            {grantee.granteeType === "group" ? (
                              <Grid item xs={4}>
                                <Box>
                                  <FormControl fullWidth >

                                    <InputLabel id="selectGroupLabel">
                                      Group
                                  </InputLabel>
                                    <Select
                                      name={grantee.key.toString()}
                                      id={grantee.key.toString()}
                                      value={grantee.grantee.toLowerCase()}
                                      label="Group"
                                      required
                                      onBlur={onGranteeBlur}
                                      error={grantee.isError}
                                      onChange={(event) =>
                                        onGranteeChange({
                                          key: grantee.key,
                                          granteeType: grantee.granteeType,
                                          grantee: event.target.value,
                                          isError: false,
                                        })
                                      }
                                      labelId="selectGroupLabel"
                                      fullWidth
                                      disabled={mode === constants.MODE.view}
                                      sx={{ textAlign: "left" }}
                                    >
                                      {accessControls.map(
                                        (
                                          item: IAccessControl,
                                          index: number,
                                          items: IAccessControl[]
                                        ) => {
                                          return (
                                            <MenuItem
                                              key={index}
                                              value={item.groupName.toLowerCase()}
                                            >
                                              {item.groupName}
                                            </MenuItem>
                                          );
                                        }
                                      )}
                                    </Select>
                                  </FormControl>

                                </Box>
                              </Grid>
                            ) : grantee.granteeType === "individual" ? (
                              <Grid item xs={4}>
                                <Box>
                                  <FormControl fullWidth >

                                    <Autocomplete
                                      options={overridesPrincipals}
                                      onSelect={onGranteeBlur}
                                      onChange={(event, value) => {
                                        let v = value as IUser;
                                        onGranteeChange({
                                          key: grantee.key,
                                          granteeType: grantee.granteeType,
                                          grantee: v.userName,
                                          isError: false,
                                        });
                                      }}
                                      getOptionLabel={(option) =>
                                        option === undefined
                                          ? " "
                                          : option.userName
                                      }
                                      isOptionEqualToValue={(option, value) =>
                                        option.userName === value.userName
                                      }
                                      //value={typeof(grantee.grantee) === 'string' ? functions.getIUser(grantee.grantee) : ''}
                                      disabled={mode === constants.MODE.view}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          name={grantee.key.toString()}
                                          value={grantee.grantee}
                                          required
                                          label="Individual"
                                          error={grantee.isError}
                                        />
                                      )}
                                    />
                                  </FormControl>
                                </Box>
                              </Grid>
                            ) : null}
                            <Grid item xs={1}>
                              <IconButton
                                color="primary"
                                aria-label="upload picture"
                                component="span"
                                onClick={() => deleteGrantee(grantee.key)}
                              >
                                <DeleteSharpIcon />
                              </IconButton>
                            </Grid>
                          </Grid>
                        </Box>
                      </React.Fragment>
                    ))}
                  </div>
                </>
              </Grid>
            ) : (
              <>
                <Grid item xs={4}>
                  <DataField id="f5a76189-05dd-48fe-a14f-2da6fec67580"
                    name="granteeType"
                    label="Grantee Type"
                    value={overrideFormData.granteeType.fieldValue}
                    readOnly={true}
                  />
                </Grid>
                <Grid item xs={4}>
                  <DataField id="0da67b4a-ac2d-4e69-aa51-5b8433bb2ce7"
                    name="grantee"
                    label="Grantee"
                    value={overrideFormData.grantee.fieldValue}
                    readOnly={true}
                  />
                </Grid>
              </>
            )}

            {mode === constants.MODE.add ? (
              <Grid item xs={12}>
                <Typography id="modal-modal-title" variant="h6" component="h2">
                  Set Expiry Date
                </Typography>
                <RadioGroup
                  row
                  name="expiry-radio-buttons-group"
                  onChange={handleChangeExpiryType}
                >
                  <FormControlLabel
                    value="days"
                    control={<Radio />}
                    label="Days"
                  />
                  <FormControlLabel
                    value="months"
                    control={<Radio />}
                    label="Months"
                  />
                  <FormControlLabel
                    value="fixedDate"
                    control={<Radio />}
                    label="Fixed Date"
                  />
                </RadioGroup>
                {expiryType === "days" ? (
                  <Box
                    component="form"
                    sx={{ "& > :not(style)": { m: 1, width: "25ch" } }}
                    noValidate
                    autoComplete="off"
                  >
                    <TextField
                      id="outlined-name"
                      label="Days"
                      name="days"
                      value={expiryValues.days.toString()}
                      InputProps={{ inputProps: { min: 0, max: 365 } }}
                      onChange={(event) => {
                        var value = parseInt(event.target.value);

                        if (value > 365) value = 365;
                        if (value < 0 || isNaN(value)) value = 0;
                        setExpiryValues({
                          ...expiryValues,
                          days: value,
                        });
                      }}
                      sx={{ width: "150px", paddingBottom: "20px" }}
                      type="number"
                    />
                  </Box>
                ) : null}
                {expiryType === "months" ? (
                  <Box
                    component="form"
                    sx={{ "& > :not(style)": { m: 1, width: "25ch" } }}
                    noValidate
                    autoComplete="off"
                  >
                    <TextField
                      id="outlined-name"
                      label="Months"
                      name="months"
                      value={expiryValues.months.toString()}
                      InputProps={{ inputProps: { min: 0, max: 12 } }}
                      onChange={(event) => {
                        var value = parseInt(event.target.value);

                        if (value > 12) value = 12;
                        if (value < 0 || isNaN(value)) value = 0;
                        setExpiryValues({
                          ...expiryValues,
                          months: value,
                        });
                      }}
                      sx={{ width: "150px", paddingBottom: "20px" }}
                      type="number"
                    />
                  </Box>
                ) : null}
                {expiryType === "fixedDate" ? (
                  <>
                    <Box
                      component="form"
                      sx={{ "& > :not(style)": { m: 1, width: "30ch" } }}
                      noValidate
                      autoComplete="off"
                    >
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          label="Fixed Date"
                          value={expiryValues.fixedDate}
                          minDate={new Date()}
                          maxDate={new Date(new Date().setFullYear(new Date().getFullYear() + 1))}
                              onChange={(newValue: Date | null) => {
                            setExpiryValues({
                              ...expiryValues,
                              fixedDate: newValue!,
                            });
                          }}
                          renderInput={(params: any) => {
                            return <TextField
                                {...params} sx={{width: "100%"}}
                            />;
                          }}
                        />
                        <FormHelperText>
                        {expiryValues.fixedDate!==null && expiryValues.fixedDate.toISOString() <  new Date().toISOString().split('T')[0] ? 'Date cannot be in the past. Please select another date.' : ''}
                        </FormHelperText>
                      </LocalizationProvider>
                    </Box>
                  </>
                ) : null}
              </Grid>
            ) : mode === constants.MODE.edit ? (

              <Grid item xs={12}>

                <Typography id="modal-modal-title" variant="h6" component="h2">
                  Set Expiry Date
                </Typography>
                <RadioGroup
                  row
                  name="expiry-radio-buttons-group"
                  onChange={handleChangeExpiryType}
                >
                  <FormControlLabel
                    value="days"
                    control={<Radio />}
                    label="Days"
                  />
                  <FormControlLabel
                    value="months"
                    control={<Radio />}
                    label="Months"
                  />
                  <FormControlLabel
                    value="fixedDate"
                    control={<Radio />}
                    label="Fixed Date"
                    checked={expiryType === "fixedDate"}
                  />
                </RadioGroup>
                {expiryType === "days" && (
                  <Box
                    component="form"
                    sx={{ "& > :not(style)": { m: 1, width: "25ch" } }}
                    noValidate
                    autoComplete="off"
                  >
                    <TextField
                      id="outlined-name"
                      label="Days"
                      name="days"
                      value={expiryValues.days}
                      InputProps={{ inputProps: { min: 0, max: 365 } }}
                      onChange={(event) => {
                        var value = parseInt(event.target.value);

                        if (value > 365) value = 365;
                        if (value < 0 || isNaN(value)) value = 0;

                        setExpiryValues({
                          ...expiryValues,
                          days: value,
                        });
                      }}
                      sx={{ width: "150px", paddingBottom: "20px" }}
                      type="number"
                    />
                  </Box>
                )}
                {expiryType === "months" && (
                  <Box
                    component="form"
                    sx={{ "& > :not(style)": { m: 1, width: "25ch" } }}
                    noValidate
                    autoComplete="off"
                  >
                    <TextField
                      id="outlined-name"
                      label="Months"
                      name="months"
                      value={expiryValues.months}
                      InputProps={{ inputProps: { min: 0, max: 12 } }}
                      onChange={(event) => {
                        var value = parseInt(event.target.value);

                        if (value > 12) value = 12;
                        if (value < 0 || isNaN(value)) value = 0;
                        setExpiryValues({
                          ...expiryValues,
                          months: value,
                        });
                      }}
                      sx={{ width: "150px", paddingBottom: "20px" }}
                      type="number"
                    />
                  </Box>
                )}
                {expiryType === "fixedDate" && (
                  <>
                    <Box
                      component="form"
                      sx={{ "& > :not(style)": { m: 1, width: "25ch" } }}
                      noValidate
                      autoComplete="off"
                    >

                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          label="Fixed Date"
                          value={expiryValues.fixedDate}
                          minDate={new Date()}
                          maxDate={new Date(new Date().setFullYear(new Date().getFullYear() + 1))}
                          onChange={(newValue: any) => {
                            setExpiryValues({
                              ...expiryValues,
                              fixedDate: newValue!,
                            });
                          }}
                          renderInput={(params: any) => <TextField
                            {...params} sx={{ width: "100%" }}
                          />}
                        />
                      </LocalizationProvider>

                    </Box>
                  </>
                )}

              </Grid>

            ) : <>
              <Grid item xs={4}>
                <DataField id="5ef4fb65-de60-49d8-9c52-094ac2d1c963"
                  label="Expiry Date"
                  name="Expiry Date"
                  value={overrideFormData.expiryDate.fieldValue}
                  readOnly={true}
                />
              </Grid>

            </>}

            <Grid item xs={12}>
              <DataField id="54c8de96-c0f7-4753-84c0-2782f307dcab"
                         type="textarea"
                         name="businessReason"
                         label="Business Reason"
                         disabled={mode === constants.MODE.view}
                         multiline={true}
                         rows={3}
                         value={overrideFormData.businessReason.fieldValue}
                         onChange={handleChange}
                         required={mode !== constants.MODE.view}
              />
            </Grid>

            <Grid item xs={12}>
              <Box display="flex" justifyContent="flex-end" m={0}>
                {mode === constants.MODE.view && isAdmin && (
                    <Button id="24c6d63f-f19c-4e3f-9f3f-196557f17caf"
                      color="primary"
                      sx={{ ml: 1}}
                      variant="contained"
                      onClick={editOverride}
                    >
                      Edit
                  </Button>
                )}
                &nbsp;
                {mode !== constants.MODE.view && (
                  <Button id="b78a5f2d-2ee5-4fc2-8805-47ca655e28b9" color="primary" variant="contained" onClick={goBack}>
                    Cancel
                  </Button>
                )}
                &nbsp;
                {mode !== constants.MODE.view && (
                  <Button id="6f01c207-08b1-4893-84ac-b1a88bae3bc4"
                    color="primary"
                    variant="contained"
                    onClick={createNewOverride}
                    disabled={disableSaveBtn}
                  >
                    Save
                  </Button>
                )}
                &nbsp;
              </Box>
            </Grid>
          </Grid>
          
        </div>
        )}
      </div>
          
    </Formik>
  );
};

export default OverrideForm;
